import * as types from "../constants/tradepanelConstants";
import * as instType from "../constants/instrumentListConstants";
import * as dashboardTypes from "../constants/dashboardConstants";
import * as commonType from "../constants/commonConstants";
import * as activitType from "../constants/activityConstants";
import * as paymentType from "../constants/paymentConstants";
import * as swapRateType from "../constants/swapRateConstants";
import * as instAction from "./instrumentListActions";
import * as activityActions from './activityActions';
import { DashboardActions } from "./dashboardActions";
import { CommonActions } from "./commonActions";
import moment from 'moment';
import config from './../config';
import appConstants from '../appConstants';
import Socket from '../utils/socket';
// import { push } from 'react-router-redux';
import { WSORDERPATH } from './../constants/index';

let orderWebsocket;
let orderSocket;
let connectionOpen = false;
let closedFromClient = false;
let masgRecvdTime = moment().valueOf();
let msgSqFlag = false;

export function clearHeartOrdInterval() {
  orderSocket?.resetSocket();
  return {
    type: instType.SUBSCRIBE_TIER,
  };
}

export function orderSellBuy(
  dispatch,
  CmdtyId,
  Quantity,
  Measure,
  DealType,
  price,
  OrderType,
  OMT,
  PCT,
  Remark,
  Validty,
  CTID,
  source,
  seq,
  time,
  RTIME,
  rate,
  tierBidRate,
  tierAskRate
) {
  const user = JSON.parse(localStorage.getItem("user"));
  const AccDet = JSON.parse(localStorage.getItem("DefaultAC"));
  if (user === null) {
    dispatch(sessionTimeout());
  }
  const platform = localStorage.getItem("platform");
  let symbol;
  let priceValue = price;
  let quant = Quantity;
  if (!priceValue) {
    priceValue = 0;
  }
  if (quant === "") {
    quant = 0;
  }

  let askRate = 0;
  let bidRate = 0;

  if (rate !== undefined) { //bug FD#18611 changes
    if (DealType === 0) {
      askRate = rate;
      bidRate = price;
    } else {
      askRate = price;
      bidRate = rate;
    }
  }

  var obj = {};
  obj.MT = "NEW_ORDER";
  obj.UID = user.id;
  obj.UCD = user.name;
  obj.IID = CmdtyId;
  obj.PQ = quant;
  obj.DT = DealType;
  obj.R = priceValue;
  obj.OT = OrderType;
  obj.CID = user.location;
  obj.AC = AccDet.AC;
  obj.AD = AccDet.AD;
  if (Measure === "") {
    obj.SC = "";
  } else {
    obj.SC = Measure;
  }
  obj.OMT = OMT;
  obj.PCT = PCT;
  obj.UUID = user.authToken;
  obj.RMK = Remark + " ";
  obj.CR = priceValue;
  obj.VD = Validty;
  obj.SID = user.sid;
  obj.CTID = CTID;
  obj.MD = -1;
  obj.SR = source;
  obj.SQ = seq;
  obj.CTIME = time;
  obj.RTIME = RTIME;
  try {
    if (orderWebsocket && connectionOpen === true) {
      orderWebsocket = orderSocket.getSocket();
      orderWebsocket.send(JSON.stringify(obj));
      if (config.PrintCommRate.includes(CmdtyId)) { // bug FD#18611 changes
        const cmdtyData = {
          userId: user.id,
          quantity: quant,
          clickedRate: priceValue,
          askRatePanel: askRate,
          bidRatePanel: bidRate,
          source: source,
          tierBidRate: tierBidRate,
          tierAskRate: tierAskRate,
          commodity: CmdtyId,
          DealType: DealType === 1 ? "BUY" : "SELL"

        }
        dispatch(CommonActions.sendErrorLogs(cmdtyData));
      }
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;
}

export function updateStatus() {
  return {
    type: instType.UPDATE_STATUS,
  };
}
export function orderSellBuyBM(
  BMC,
  BMN,
  BEMT,
  CmdtyPair,
  Quantity,
  Measure,
  DealType,
  price,
  OrderType,
  OMT,
  PCT,
  Remark,
  tenorDate,
  CTID,
  FD,
  TD,
  REPEAT,
  FwdPerc,
  selectedTenor,
  spotDate
) {
  const user = JSON.parse(localStorage.getItem("user"));
  const AccDet = JSON.parse(localStorage.getItem("DefaultAC"));
  if (user === null) {
    dispatch(sessionTimeout());
  }
  const platform = localStorage.getItem("platform");
  let symbol;
  let priceValue = price;
  let quant = Quantity;
  if (!priceValue) {
    priceValue = 0;
  }
  if (quant === "") {
    quant = 0;
  }

  var obj = {};
  obj.MT = "NEW_ORDER";
  obj.UID = user.id;
  obj.UCD = user.name;
  obj.IID = CmdtyPair;
  obj.PQ = parseFloat(quant).toFixed(3);
  obj.DT = DealType;
  obj.R = priceValue;
  obj.OT = OrderType;
  obj.CID = user.location;
  obj.AC = AccDet.AC;
  obj.AD = AccDet.AD;
  if (Measure === "") {
    obj.SC = "";
  } else {
    obj.SC = Measure;
  }
  obj.OMT = OMT;
  obj.PCT = PCT;
  obj.UUID = user.authToken;
  obj.RMK = Remark + " ";
  obj.VD = moment(tenorDate).format("YYYY/MM/DD");
  obj.TENOR = selectedTenor;
  obj.FWDPER = FwdPerc; // Forward %
  obj.ISFWD_OR = (FwdPerc === 0 || FwdPerc === "0.00" || FwdPerc === 0.00) ? false : true;
  obj.SID = user.sid;
  obj.BMC = BMC;
  obj.BMN = BMN;
  obj.BEMT = BEMT;
  obj.UTCT = "";
  obj.OMC = 0;
  obj.DRMK = "";
  obj.ST = "";
  obj.CTID = CTID;
  obj.MD = -1;
  obj.FD = moment(FD).format("YYYY-MM-DD");
  obj.TD = moment(TD).format("YYYY-MM-DD");
  obj.REPEAT = REPEAT;
  obj.ISAPPLY = REPEAT;
  obj.isSNEXrmk = false;
  obj.ISVD_OR = selectedTenor !== "SPOT" && moment(spotDate).isBefore(moment(tenorDate), 'day') ? true : false;
  try {
    if (orderWebsocket && connectionOpen === true) {
      orderWebsocket = orderSocket.getSocket();
      orderWebsocket.send(JSON.stringify(obj));
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;
}

export function modifyBM(
  BMC,
  BMN,
  BEMT,
  CmdtyPair,
  Quantity,
  Measure,
  DealType,
  price,
  OrderType,
  OMT,
  PCT,
  Remark,
  ValueDate,
  CTID,
  OPQ,
  OR,
  OSC,
  PCLD,
  ONB,
  OMC,
  DRMK,
  AC,
  AD,
  FD,
  TD,
  APPLY,
  REPEAT,
  FwdPerc,
  selectedTenor,
  isSNEXrmk,
  isVDSelected
) {
  const user = JSON.parse(localStorage.getItem("user"));
  const AccDet = JSON.parse(localStorage.getItem("DefaultAC"));
  if (user === null) {
    dispatch(sessionTimeout());
  }
  const platform = localStorage.getItem("platform");
  let symbol;
  let priceValue = price;
  let quant = Quantity;
  if (!priceValue) {
    priceValue = 0;
  }
  if (quant === "") {
    quant = 0;
  }

  var obj = {};
  obj.MT = "MODIFY_ORDER";
  obj.UID = user.id;
  obj.UCD = user.name;
  obj.IID = CmdtyPair;
  obj.PQ = parseFloat(quant).toFixed(3);
  obj.DT = DealType;
  obj.R = priceValue;
  obj.OT = OrderType;
  obj.CID = user.location;
  obj.AC = AC;
  obj.AD = AD;
  if (Measure === "") {
    obj.SC = "";
  } else {
    obj.SC = Measure;
  }
  obj.OMT = OMT;
  obj.PCT = PCT;
  obj.UUID = user.authToken;
  obj.RMK = Remark + " ";
  obj.VD = moment(ValueDate).format("YYYY/MM/DD");
  obj.SID = user.sid;
  obj.BMC = BMC;
  obj.BMN = BMN;
  obj.BEMT = BEMT;
  obj.UTCT = "";
  obj.OMC = OMC;
  obj.DRMK = DRMK;
  obj.ST = "";
  obj.CTID = CTID;
  obj.MD = -1;
  obj.OPQ = OPQ;
  obj.OR = OR;
  obj.OSC = OSC;
  obj.PCLD = PCLD;
  obj.ONB = ONB;
  obj.FD = FD;
  // obj.TD=TD;
  obj.REPEAT = REPEAT;
  obj.ISAPPLY = APPLY;
  obj.TENOR = selectedTenor;
  obj.FWDPER = FwdPerc;
  obj.ISFWD_OR = (FwdPerc === 0 || FwdPerc === "0.00" || FwdPerc === 0.00) ? false : true;
  obj.isSNEXrmk = isSNEXrmk ? isSNEXrmk : false;
  obj.ISVD_OR = isVDSelected;
  // obj.ISVD_OR = selectedTenor !== "SPOT" && moment(spotDate).isBefore(moment(tenorDate), 'day') ? true : false;

  try {
    if (orderWebsocket && connectionOpen === true) {
      orderWebsocket = orderSocket.getSocket();
      orderWebsocket.send(JSON.stringify(obj));
    } else {
      //alert("Deal Failed");
      return false;
    }
  } catch (e) {
    //alert("Deal Failed");
    return false;
  }
  return true;
}

export function cancelBM(orderDetailsArray, OrderType, OMT, PCT) {
  const user = JSON.parse(localStorage.getItem("user"));
  const AccDet = JSON.parse(localStorage.getItem("DefaultAC"));
  if (user === null) {
    dispatch(sessionTimeout());
  }
  const platform = localStorage.getItem("platform");
  let symbol;
  var tempAr = [];
  var obj = {};
  obj.MT = "CANCEL_ORDER";
  obj.UID = user.id;
  obj.UCD = user.name;
  obj.OMT = OMT;
  obj.PCT = PCT;
  obj.OT = OrderType;
  obj.CID = user.location;
  obj.SID = user.sid;
  obj.UUID = user.authToken;
  orderDetailsArray.map((orderDetails) => {
    var obj1 = {};
    const socketData = Object.assign(
      [],
      JSON.parse(localStorage.getItem("socketDataStatic"))
    );
    let index1;
    for (let index2 = 0; index2 < socketData.length; index2++) {
      const cmdty = socketData[index2].ID;
      if (cmdty === orderDetails.cmdtyPair) {
        index1 = index2;
      }
    }
    let CmdtyPair = socketData[index1].I;
    let priceValue = orderDetails.OR;
    let quant = orderDetails.quantity;
    if (!priceValue) {
      priceValue = 0;
    }
    if (quant === "") {
      quant = 0;
    }
    obj1.AC = orderDetails.accCode;
    obj1.AD = orderDetails.accDescription;
    obj1.ONB = orderDetails.orderNo;
    obj1.PQ = quant;
    obj1.DT = orderDetails.deal === "BUY" ? 1 : 0;
    obj1.OT = OrderType;
    obj1.R = priceValue;
    if (orderDetails.OSC === "") {
      obj1.SC = "";
    } else {
      obj1.SC = orderDetails.OSC;
    }
    obj1.RMK = orderDetails.comments + " ";
    obj1.BID = "";
    obj1.IID = CmdtyPair;
    obj1.OMC = orderDetails.OMC;
    obj1.DRMK = orderDetails.DRMK;
    obj1.BMC = orderDetails.BMC;
    obj1.BMN = orderDetails.benchmark;
    obj1.BEMT = orderDetails.BEMT;
    obj1.UTCT = "";
    obj1.PCLD = orderDetails.id;
    obj1.FD = moment(orderDetails.FD).format("YYYY-MM-DD");
    obj1.FWDPER = orderDetails.fwdPerc ? orderDetails.fwdPerc : 0;
    obj1.VD = orderDetails.fwdVD ? moment(orderDetails.fwdVD).format("YYYY/MM/DD") : "";
    obj1.TENOR = orderDetails.tenor ? orderDetails.tenor : "";
    // obj1.REPEAT=orderDetails.REPEAT;
    tempAr.push(obj1);
  });
  obj.ARR = tempAr;

  try {
    if (orderWebsocket && connectionOpen === true) {
      orderWebsocket = orderSocket.getSocket();
      orderWebsocket.send(JSON.stringify(obj));
    } else {
      //alert("Deal Failed");
      return false;
    }
  } catch (e) {
    //alert("Deal Failed");
    return false;
  }
  return true;
}

export function updateCustMargin(msg) {
  return {
    type: instType.UPDATE_MARGIN_PERC,
    msg,
  };
}
export function updateNewsFeed(msg) {
  return {
    type: newsFeed.UPDATE_NEWSFEED,
    msg,
  };
}
export function setTradingstatus(status) {
  return {
    type: types.TRD_STATUS,
    status,
  };
}
export function accDeactivation(msg) {
  const data = JSON.parse(localStorage.getItem("TS"));
  const accList = data.ACD || [];
  const matchedAcc = accList.find((item) => item.C === msg.ACC);
  let isAccDeactivate = false;
  let isAccDeactivateSingleAcc = false;

  if (matchedAcc && msg.ACC_STATUS === "0") {
    if (accList.length === 1) {
      isAccDeactivateSingleAcc = true;
    } else {
      isAccDeactivate = true;
    }
  }
  return {
    type: types.ACC_DEACTIVATION_UPDATE,
    payload: {
      isAccDeactivate,
      isAccDeactivateSingleAcc,
      matchedAcc
    },
  };
}

export const clearAccDeactivation = () => ({
  type: types.CLEAR_ACC_DEACTIVATION,
});

export function killSessionTrader(msg, flag) {
  const key = true;
  clearHeartOrdInterval();
  if (flag !== true) {
    localStorage.setItem("user", null);
  }
  localStorage.setItem("userlogin", null);
  localStorage.setItem("logoutClose", "true");
  instAction.resetStateSocket();
  instAction.closeSocketData();
  return {
    type: commonType.KILL_SESSION,
    key,
    msg,
    flag,
  };
}
export function sessionReset() {
  localStorage.setItem("logoutClose", "true");
  clearHeartOrdInterval();
  instAction.closeSocketData();
  closeSocketTrade();
  return {
    type: instType.SUBSCRIBE_TIER, //this type does nothing hnce used
  };
}
export function killlogout() {
  localStorage.setItem('logoutClose', 'true');
  // instAction.closeSocketData();
  closeSocketTrade();
}
export function tradeMasterChnage(msg) {
  try {
    var TS = {};
    TS = JSON.parse(localStorage.getItem("TS"));
    TS.ACD = msg.ACD;
    localStorage.setItem("TS", JSON.stringify(TS));
    return {
      type: commonType.FORCED_LOGOUT,
      msg
    };
  } catch (e) {
    console.log(e);
  }
}
export function actLogRmkGenerator(msg) {
  return {
    type: activitType.UPDATE_ACTIVITYCOMPONENT,
    msg,
  };
}
export function actLogGeneratorForPayment(msg) {
  return {
    type: activitType.UPDATE_ACTIVITYDATA,
    msg,
  };
}

export function updateAvgBMK(msg) {
  return {
    type: activitType.UPDATE_AVG_BMK,
    msg,
  };
}

export function updatePaymentReuestData(msg) {
  return {
    type: paymentType.UPDATE_PAY_REQ_DET,
    msg,
  };
}
export function updatePaySSIDetails(msg) {
  return {
    type: paymentType.UPDATE_PAY_SSI_DEP,
    msg,
  };
}
export function updatePayHolidayMaster(msg) {
  return {
    type: paymentType.UPDATE_HOLIDAY_LIST,
    msg,
  };
}
export function addPMRHoliday(msg) {
  return {
    type: paymentType.ADD_PMR_HOLIDAY,
    msg,
  };
}
export function deletePMRHoliday(msg) {
  return {
    type: paymentType.DELETE_PMR_HOLIDAY,
    msg,
  };
}

export function updateOrdBmkMRK(msg) {
  return {
    type: activitType.UPDATE_ORD_BMK_MRK,
    msg,
  };
}
export function updateOrdsMrk(msg) {
  return {
    type: activitType.UPDATE_ORD_MRK,
    msg,
  };
}
export function updateAccountBalance(msg) {
  return {
    type: instType.UPDATE_ACCBAL,
    msg,
  };
}
export function updateStock(msg) {
  return {
    type: instType.UPDATE_INST,
    msg,
  };
}
export function updateNewsFeedData(message) {
  return {
    type: commonType.UPDATE_NEWSFEED,
    message,
  };
}

export function updateSwapRates(msg) {
  return {
    type: swapRateType.UPDATE_SWAP_RATE_DET,
    msg,
  };
}

export function getBenchMark(valdate) {
  let startDate = moment(valdate).format('YYYY-MM-DD');
  const user = JSON.parse(localStorage.getItem('user'));
  if (user) {
    const data = `CID=${user.location}&username=${user.id}&FD=${startDate}&isTrd=${true}&isForFill=false`
    const valDate = valdate;
    return (dispatch) => {
      dispatch(CommonActions.handleAPICall(data, '/GetValidBenchmarks', types.GETBM, 'GET', { valDate }));
    };
  }
  // return {
  //         types: [types.GETBM, types.GETBM_SUCCESS, types.GETBM_FAILURE],
  //           valDate,
  //           promise: (client) => client.get(`/GetValidBenchmarks?CID=${user.location}&username=${user.id}&FD=${startDate}&isTrd=${true}&isForFill=false`)
  // };
}
// Updating socket data for trade
export function updateTradeSocketData(message) {
  return {
    type: types.UPDATE_TRADE_SOCKET_DATA,
    message,
  };
}
export function updateValueDate(message) {
  return {
    type: instType.UPDATE_VALUEDATE,
    message,
  };
}
export function updateBenchmark(message) {
  return {
    type: types.CUTOFF_BENCHMARK,
    message,
  };
}
export function editBenchmark(message) {
  return {
    type: types.UPDATE_BM_LIST,
    message,
  };
}
export function closeAlert() {
  return {
    type: types.HIDE_ALERT,
  };
}
export function showAlert(msg) {
  return {
    type: types.SHOW_ALERT,
    msg,
  };
}
export function sucessOrderTrade() {
  return (dispatch) => {
    dispatch({
      type: types.ORDER_SUCCESS,
    });
  };
}

// To show trade execution, coming through web socket
export function sucessExecuteTrade(data) {
  return (dispatch) => {
    dispatch({
      type: types.EXECUTE_SUCCESS,
      data,
    });
  };
}

export function sessionTimeout() {
  return (dispatch) => {
    dispatch({
      type: dashboardTypes.SESSION_TIMEOUT,
    });
  };
}

// function to be called for sending HB
function sendHeartbeat(ws) {
  let obj = {};
  obj.MT = "HEARTBEAT";
  ws.send(JSON.stringify(obj));
  connectionOpen = true;
}

// function to be called for updating proximity
function updateProximity(dispatch) {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user !== null) {
    dispatch(instAction.refreshProximity());
  }
}

// function to be called after opening
function callOnOpening() {
  return [sendHeartbeat, updateProximity];
}

// function to be called after receiving messages
function callOnMessage(dispatch, event) {
  const msg = JSON.parse(event.data);

  // handle different types of BCM
  switch (msg.BCM) {
    case appConstants.ACC_BAL_UPDATE:
      dispatch(updateAccountBalance(msg));
      break;
    case appConstants.MSG_TO_TRD:
      dispatch(showAlert(msg));
      break;
    case appConstants.UPDATE_STOCK:
      dispatch(updateStock(msg));
      break;
    case appConstants.UPDATE_CUST_MARGIN:
      dispatch(updateCustMargin(msg));
      break;
    case appConstants.TRD_MASTER_CNG:
      dispatch(tradeMasterChnage(msg));
      break;
    case appConstants.NEWS_FEED:
      dispatch(updateNewsFeedData(msg));
      break;
    case appConstants.KILL_TRD_SES:
      localStorage.setItem("logoutClose", "true");
      dispatch(killSessionTrader("Session killed By Dealer", false));
      dispatch(DashboardActions.loadTemplateFlag(false));
      dispatch(activityActions.disconnectNotificationStream())
      killlogout();
      break;
    case appConstants.ERROR_MSG:
      localStorage.setItem("logoutClose", "true");
      dispatch(killSessionTrader("Session Expired.", false));
      dispatch(DashboardActions.loadTemplateFlag(false));
      dispatch(activityActions.disconnectNotificationStream())
      killlogout();
      break;
    case appConstants.FORCED_LOGOUT:
      localStorage.setItem("logoutClose", "true");
      dispatch(killSessionTrader("Your Session has been terminated.", false));
      dispatch(DashboardActions.loadTemplateFlag(false));
      dispatch(activityActions.disconnectNotificationStream())
      killlogout();
      break;
    case appConstants.TRADING_STATUS_CHANGED:
      const tradingStatus = msg.TrdST === 1 ? "true" : "false";
      dispatch(setTradingstatus(tradingStatus));
      break;
    case appConstants.END_OF_DAY:
      localStorage.setItem("logoutClose", "true");
      dispatch(
        killSessionTrader(
          "This trading session has ended, Please login again",
          false
        )
      );
      dispatch(DashboardActions.loadTemplateFlag(false));
      killlogout();
      break;
    case appConstants.UPDATE_VALUE_DATE:
      dispatch(updateValueDate(msg));
      break;
    case appConstants.BENCHMARK_CUTOFF:
      dispatch(updateBenchmark(msg));
      break;
    case appConstants.UPDATE_BMDETAILS:
      dispatch(editBenchmark(msg));
      break;
    case appConstants.PAYMENT_REQUEST_PLACED:
      dispatch(actLogGeneratorForPayment(msg));
      break;
    case appConstants.PAYMENT_REQUEST_FAIL:
      dispatch(actLogGeneratorForPayment(msg));
      break;
    case appConstants.PAYMENT_REQUEST_APRVREJ:
      dispatch(actLogGeneratorForPayment(msg));
      dispatch(updatePaymentReuestData(msg));
      break;
    case appConstants.PAYMENT_REQ_UPDATE:
      dispatch(actLogGeneratorForPayment(msg));
      dispatch(updatePaymentReuestData(msg));
      break;
    case appConstants.AVGBMK_ORDER_PLACED:
      dispatch(updateAvgBMK(msg));
      break;
    case appConstants.AVGBMK_ORDER_MODIFIED:
      dispatch(updateAvgBMK(msg));
      break;
    case appConstants.AVGBMK_ORDER_CANCELLED:
      dispatch(updateAvgBMK(msg));
      break;
    case appConstants.BENCHMARK_MANUAL_FILL:
      dispatch(updateAvgBMK(msg));
      break;
    case appConstants.AVGBMK_REVERSE_REBOOK:
      dispatch(updateAvgBMK(msg));
      break;
    case appConstants.UPDATE_PR_SSI:
      dispatch(updatePaySSIDetails(msg));
      break;
    case appConstants.UPDATE_PR_CUTOFF:
      dispatch(updatePaySSIDetails(msg));
      break;
    case appConstants.UPDATE_HOLIDAY:
      dispatch(updatePayHolidayMaster(msg));
      break;
    case appConstants.UPDATE_SWAP_RATE:
      dispatch(updateSwapRates(msg));
      break;
      break;
    case appConstants.ADD_PMR_HOLIDAY:
      dispatch(addPMRHoliday(msg));
      break;
    case appConstants.DELETE_PMR_HOLIDAY:
      dispatch(deletePMRHoliday(msg));
      break;
    case appConstants.UPDATE_MARKUP:
      dispatch(updateOrdBmkMRK(msg));
      break;
    case appConstants.UPDATE_EFP:
      dispatch(updateOrdsMrk(msg));
      break;
    case appConstants.WS_RECONNECT:
      dispatch(reconnectSocketCon());
      break;
    case appConstants.UPDATE_FNC_RMK:
      dispatch(actLogRmkGenerator(msg));
      break;
    case appConstants.ACC_DEACTIVATION:
      dispatch(accDeactivation(msg));
      break;
  }

  const USER = JSON.parse(localStorage.getItem("user"));
  if (
    msg.BCM === appConstants.INITIAL_CHECKS_FAILED &&
    msg.STATUS === appConstants.REJ_ACCLOCKED
  ) {
    if (msg.UID === USER.id) {
      dispatch(actLogRmkGenerator(msg));
    }
  } else if (
    JSON.parse(localStorage.getItem("TS")).DCO.indexOf(msg.IID) !== -1
  ) {
    dispatch(actLogRmkGenerator(msg));
  }
}

// function to be called after disconnection
function callOnDisconnect(dispatch) {
  dispatch(clearHeartOrdInterval());
  dispatch(killSessionTrader("Session Expired", false));
  killlogout();
}

// functions to be called after rate and order reconnection
function callOnReconnect(dispatch) {
  connectionOpen = false;
}

// new socket connection logic
export function loadSocketTrade(dispatch) {
  // need to declare constants here to get non-null values
  const USER = JSON.parse(localStorage.getItem("user"));
  const PLATFORM = localStorage.getItem("platform");

  // check if user data exists
  if (USER === null) {
    dispatch(sessionTimeout());
  } else {
    // establish websocket connection
    orderSocket = new Socket();
    const orderWSParams = {
      url: WSORDERPATH + "/order/trader",
      params: [
        "neo-ws-protocol",
        "UID|" + USER.id,
        "token|" + USER.authToken,
        "platform|" + PLATFORM,
        "SID|" + USER.sid,
        "CID|" + USER.location,
      ],
    };
    orderWebsocket = orderSocket.connectSocket(orderWSParams, dispatch, callOnOpening, callOnMessage, callOnDisconnect, callOnReconnect);
  }
}

// Load socket data for trade
export function loadSocketTradeData() {
  return (dispatch) => {
    dispatch({
      type: [types.LOAD_TRADE_SOCKET_DATA],
      socketData: loadSocketTrade(dispatch),
    });
  };
}

export function reconnectSocketCon() {
  if (orderWebsocket) {
    orderWebsocket.close();
  }
  connectionOpen = false;
  instAction.reconnectRateSocketCon();
  loadSocketTrade();
}

export function closeSocketConTrade() {
  if (orderWebsocket) {
    closedFromClient = true;
    orderWebsocket.close();
  }
}

// Closing web socket if trade inProgress
export function closeWebSocketTrade() {
  return {
    type: types.CLOSE_WEBSOCKET_TRADE
  };
}
// Closing socket data for trade
export function closeSocketTrade() {
  return {
    type: types.CLOSE_SOCKET_TRADE,
    socketData: closeSocketConTrade(),
  };
}
// Handle sell or buy operation on trade panel
export function handleSellBuyOrder(
  CmdtyPair,
  Quantity,
  Measure,
  DealType,
  price,
  OrderType,
  OMT,
  PCT,
  Remark,
  Validty,
  CTID,
  source,
  seq,
  time,
  RTIME,
  rate,
  tierBidRate,
  tierAskRate
) {
  return (dispatch) => {
    return {
      type: activitType.GET_TRADE_CTID,
      order: orderSellBuy(
        dispatch,
        CmdtyPair,
        Quantity,
        Measure,
        DealType,
        price,
        OrderType,
        OMT,
        PCT,
        Remark,
        Validty,
        CTID,
        source,
        seq,
        time,
        RTIME,
        rate,
        tierBidRate,
        tierAskRate
      ),
      ctid: CTID,
    };
  };
}
export function handleBMOrder(
  BMC,
  BMN,
  BEMT,
  CmdtyPair,
  Quantity,
  Measure,
  DealType,
  price,
  OrderType,
  OMT,
  PCT,
  Remark,
  tenorDate,
  CTID,
  FD,
  TD,
  REPEAT,
  FwdPerc,
  selectedTenor,
  spotDate
) {
  return {
    type: activitType.DEAL_FAILED_FLAG,
    order: orderSellBuyBM(
      BMC,
      BMN,
      BEMT,
      CmdtyPair,
      Quantity,
      Measure,
      DealType,
      price,
      OrderType,
      OMT,
      PCT,
      Remark,
      tenorDate,
      CTID,
      FD,
      TD,
      REPEAT,
      FwdPerc,
      selectedTenor,
      spotDate
    ),
  };
}

export function modifyBMOrder(
  BMC,
  BMN,
  BEMT,
  CmdtyPair,
  Quantity,
  Measure,
  DealType,
  price,
  OrderType,
  OMT,
  PCT,
  Remark,
  ValueDate,
  CTID,
  OPQ,
  OR,
  OSC,
  PCLD,
  ONB,
  OMC,
  DRMK,
  AC,
  AD,
  FD,
  TD,
  APPLY,
  REPEAT,
  FwdPerc,
  selectedTenor,
  isSNEXrmk,
  isVDSelected
) {
  return {
    type: activitType.DEAL_FAILED_FLAG,
    order: modifyBM(
      BMC,
      BMN,
      BEMT,
      CmdtyPair,
      Quantity,
      Measure,
      DealType,
      price,
      OrderType,
      OMT,
      PCT,
      Remark,
      ValueDate,
      CTID,
      OPQ,
      OR,
      OSC,
      PCLD,
      ONB,
      OMC,
      DRMK,
      AC,
      AD,
      FD,
      TD,
      APPLY,
      REPEAT,
      FwdPerc,
      selectedTenor, isSNEXrmk,
      isVDSelected
    ),
  };
}

export function cancelBMOrder(orderDetailsArray, OrderType, OMT, PCT) {
  return {
    type: activitType.DEAL_FAILED_FLAG,
    order: cancelBM(orderDetailsArray, OrderType, OMT, PCT),
  };
}
// Hide modal
export function modalHide() {
  return {
    type: types.HIDE_MODAL,
  };
}
export function handleSellBuyLMTOrder(
  CmdtyPair,
  tempQ,
  selectedMeasure,
  DealType,
  Price,
  OrderType,
  OMT,
  PCT,
  remark,
  ValidityType,
  CTID,
  datetime,
  VD
) {
  return {
    type: activitType.DEAL_FAILED_FLAG,
    order: orderSellBuyLMT(
      CmdtyPair,
      tempQ,
      selectedMeasure,
      DealType,
      Price,
      OrderType,
      OMT,
      PCT,
      remark,
      ValidityType,
      CTID,
      datetime,
      VD
    ),
  };
}
export function orderSellBuyLMT(
  CmdtyPair,
  Quantity,
  Measure,
  DealType,
  Price,
  OrderType,
  OMT,
  PCT,
  remark,
  ValidityType,
  CTID,
  datetime,
  VD
) {
  const user = JSON.parse(localStorage.getItem("user"));
  const AccDet = JSON.parse(localStorage.getItem("DefaultAC"));
  if (user === null) {
    dispatch(sessionTimeout());
  }
  const platform = localStorage.getItem("platform");
  var obj = {};
  obj.MT = "NEW_ORDER";
  obj.UID = user.id;
  obj.UCD = user.name;
  obj.IID = CmdtyPair;
  obj.PQ = Quantity;
  obj.DT = DealType;
  obj.R = Price;
  obj.OT = OrderType;
  obj.CID = user.location;
  obj.AC = AccDet.AC;
  obj.AD = AccDet.AD;
  if (Measure === "") {
    obj.SC = "";
  } else {
    obj.SC = Measure;
  }
  obj.ST = "";
  obj.OMT = OMT;
  obj.PCT = PCT;
  obj.UUID = user.authToken;
  obj.RMK = remark;
  obj.DRMK = "";
  obj.MD = -1;
  obj.VD = VD;
  obj.SID = user.sid;
  obj.CTID = CTID;
  obj.VT = ValidityType; //validity, ValidityType class
  obj.OMC = 0; //order modification count
  obj.TIME = datetime; //epoch UTC timestamp
  obj.isSNEXrmk = false;

  try {
    if (orderWebsocket && connectionOpen === true) {
      orderWebsocket = orderSocket.getSocket();
      orderWebsocket.send(JSON.stringify(obj));
    }
    else {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;
}
export function handleModifyLMTOrder(
  CmdtyPair,
  tempQ,
  selectedMeasure,
  DealType,
  Price,
  orderType,
  OMT,
  PCT,
  remark,
  VT,
  CTID,
  datetime,
  OPQ,
  OR,
  OVT,
  OSC,
  NOD,
  BID,
  PCLD,
  DRMK,
  HSE,
  VD,
  AC,
  AD,
  OTIME,
  isSNEXrmk,
  DOT,
  ISOTO = false,
  ISOCO = false,
  ISACTIVE = false,
  linkclid = '',
  isLooped = false
) {
  return {
    type: activitType.DEAL_FAILED_FLAG,
    order: orderLMTModify(
      CmdtyPair,
      tempQ,
      selectedMeasure,
      DealType,
      Price,
      orderType,
      OMT,
      PCT,
      remark,
      VT,
      CTID,
      datetime,
      OPQ,
      OR,
      OVT,
      OSC,
      NOD,
      BID,
      PCLD,
      DRMK,
      HSE,
      VD,
      AC,
      AD,
      OTIME, isSNEXrmk,
      DOT,
      ISOTO,
      ISOCO,
      ISACTIVE,
      linkclid,
      isLooped
    ),
  };
}
export function orderLMTModify(
  CmdtyPair,
  tempQ,
  Measure,
  DealType,
  Price,
  orderType,
  OMT,
  PCT,
  remark,
  VT,
  CTID,
  datetime,
  OPQ,
  OR,
  OVT,
  OSC,
  NOD,
  BID,
  PCLD,
  DRMK,
  HSE,
  VD,
  AC,
  AD,
  OTIME, isSNEXrmk,
  DOT,
  ISOTO,
  ISOCO,
  ISACTIVE,
  linkclid,
  isLooped,
) {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user === null) {
    dispatch(sessionTimeout());
  }
  var obj = {};
  obj.UID = user.id;
  obj.UCD = user.name;
  obj.IID = CmdtyPair;
  obj.PQ = tempQ;
  obj.DT = DealType;
  obj.R = Price;
  obj.OT = orderType;
  if (orderType === appConstants.OCO_ORD_TYPE) {
    obj.DOT = DOT;
    if (orderType === appConstants.STOP_ORD_TYPE) {
      obj.isStop = true;
    }
    obj.isStop = false;
  }
  obj.CID = user.location;
  obj.AC = AC;
  obj.AD = AD;
  obj.VD = VD;
  if (Measure === "") {
    obj.SC = "";
  } else {
    obj.SC = Measure;
  }
  obj.ST = "";
  obj.OMT = OMT;
  obj.PCT = PCT;
  obj.UUID = user.authToken;
  obj.RMK = remark;
  obj.SID = user.sid;
  obj.CTID = CTID;
  obj.VT = VT; //validity, ValidityType class
  obj.OMC = 1; //order modification count
  obj.TIME = datetime; //epoch UTC timestamp
  obj.OPQ = OPQ; //old PQ
  obj.OR = OR;
  obj.OVT = OVT;
  obj.OSC = OSC;
  obj.NOD = NOD;
  obj.HSE = HSE;
  obj.BID = BID; //check if this is needed in new system, can be managed in server
  obj.OTIME = OTIME; //old time for GTD orders
  obj.LM = "admin";
  obj.MD = "-1";
  obj.PCLD = PCLD;
  obj.DRMK = DRMK;
  obj.MT = "MODIFY_ORDER";
  obj.ISOTO = ISOTO;
  obj.ISOCO = ISOCO;
  obj.INLOOP = isLooped;
  obj.ISACTIVE = ISACTIVE;
  obj.OtoLinkOrdId = linkclid,
    obj.isSNEXrmk = isSNEXrmk ? isSNEXrmk : false;
  try {
    if (orderWebsocket && connectionOpen === true) {
      orderWebsocket = orderSocket.getSocket();
      orderWebsocket.send(JSON.stringify(obj));
    } else {
      // alert("Deal Failed");
      return false;
    }
  } catch (e) {
    console.log(" exception " + e);
    //alert("Deal Failed");
    return false;
  }
  return true;
}
export function handleCancelledLMT(orderDetailsArray, OMT, PCT) {
  return {
    type: activitType.DEAL_FAILED_FLAG,
    order: orderLMTCancelled(orderDetailsArray, OMT, PCT),
  };
}
export function orderLMTCancelled(orderDetailsArray, OMT, PCT) {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user === null) {
    dispatch(sessionTimeout());
  }
  var obj = {};
  var arr = [];
  const socketData = Object.assign(
    [],
    JSON.parse(localStorage.getItem("socketDataStatic"))
  );
  let index1;
  orderDetailsArray.map((order) => {
    for (let index2 = 0; index2 < socketData.length; index2++) {
      const cmdty = socketData[index2].ID;
      if (cmdty === order.cmdtyPair) {
        index1 = index2;
      }
    }
    let CmdtyPair = socketData[index1].I;
    var obj1 = {
      AC: order.accCode,
      AD: order.accDescription,
      NOD: order.orderNo,
      PQ: order.quantity,
      DT: order.deal === "BUY" ? 1 : 0,
      OT: order.OT, //In future stop orders might come, so OT inside array
      R: order.OR,
      SC: order.OSC, //this is only for metals, for forex this will be blank
      ST: "", //This is for future use, for stop type
      RMK: order.comments + " ",
      BID: "", //check if this is needed in new system, can be managed in server
      IID: CmdtyPair,
      VT: order.VT, //validity, ValidityType class
      TIME: order.TIME, //epoch UTC timestamp
      OMC: order.OMC, //order modification count, check if this can be managed in server
      DRMK: order.DRMK,
      PCLD: order.id,
      LM: "admin",
      ISOTO: order?.ISOTO ?? false,
      INLOOP: order?.INLOOP ?? false,
    };
    arr.push(obj1);
  });
  obj.UID = user.id;
  obj.UCD = user.name;
  obj.OMT = OMT;
  obj.PCT = PCT;
  obj.CID = user.location;
  obj.SID = user.sid;
  obj.UUID = user.authToken;
  obj.MT = "CANCEL_ORDER";
  obj.MD = -1;
  obj.ARR = arr;
  try {
    if (orderWebsocket && connectionOpen === true) {
      orderWebsocket = orderSocket.getSocket();
      orderWebsocket.send(JSON.stringify(obj));
    } else {
      // alert("Deal Failed");
      return false;
    }
  } catch (e) {
    //  alert("Deal Failed");
    return false;
  }
  return true;
}
export function updatePopoutCount(popoutLimit) {
  return {
    type: types.UPDATE_POPOUT_COUNT,
    popoutLimit,
  };
}
export function handlePaymentReq(
  PQ,
  SSI,
  CCYN,
  CCY,
  accCode,
  accDes,
  VD,
  remark,
  stkGrp
) {
  return {
    type: types.ADD_PAYMENT_REQUEST,
    paymentReq: addPaymentRequest(
      PQ,
      SSI,
      CCYN,
      CCY,
      accCode,
      accDes,
      VD,
      remark,
      stkGrp
    ),
  };
}
export function addPaymentRequest(
  PQ,
  SSI,
  CCYN,
  CCY,
  accCode,
  accDes,
  VD,
  remark,
  stkGrp
) {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user === null) {
    dispatch(sessionTimeout());
  }
  var obj = {};
  obj.SID = user.sid;
  obj.UUID = user.authToken;
  obj.UID = user.id;
  obj.UCD = user.name;
  obj.OMT = 1;
  obj.CID = user.location;
  obj.AC = accCode;
  obj.AD = accDes;
  obj.PQ =
    stkGrp === "M"
      ? parseFloat(PQ).toFixed(config.QuantityRoundOff)
      : parseFloat(PQ).toFixed(2);
  obj.RMK = remark + " ";
  obj.CCY = CCY;
  obj.CCYN = CCYN;
  obj.CCYG = stkGrp;
  obj.VD = moment(VD).format("YYYY/MM/DD");
  obj.SSI = SSI;
  // obj.LOC=(stkGrp === 'C' ? " ":loc);
  // obj.LOCD=(stkGrp === 'C' ? " ":LOCD);
  obj.MT = "PAYMENT_REQUEST";
  try {
    if (orderWebsocket && connectionOpen === true) {
      orderWebsocket = orderSocket.getSocket();
      orderWebsocket.send(JSON.stringify(obj));
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;
}
export function modifyPaymentReq(
  PQ,
  ssi,
  location,
  LOCD,
  cmdty,
  CCYN,
  acCode,
  accDet,
  valueDate,
  remark,
  docNo,
  stkGrp
) {
  return {
    type: types.MODIFY_PAYMENT_REQUEST,
    paymentReq: modifyPaymentRequest(
      PQ,
      ssi,
      location,
      LOCD,
      cmdty,
      CCYN,
      acCode,
      accDet,
      valueDate,
      remark,
      docNo,
      stkGrp
    ),
  };
}
export function modifyPaymentRequest(
  PQ,
  ssi,
  location,
  LOCD,
  cmdty,
  CCYN,
  acCode,
  accDet,
  valueDate,
  remark,
  docNo,
  stkGrp
) {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user === null) {
    dispatch(sessionTimeout());
  }
  var obj = {};
  obj.SID = user.sid;
  obj.UUID = user.authToken;
  obj.UID = user.id;
  obj.UCD = user.name;
  obj.CID = user.location;
  obj.AC = acCode;
  obj.AD = accDet;
  obj.RMK = remark + " ";
  obj.CCY = cmdty;
  obj.CCYN = CCYN;
  obj.CCYG = stkGrp;
  obj.VD = moment(valueDate).format(appConstants.paymentDateFormat);
  obj.SSI = ssi;
  //obj.LOC=(stkGrp === 'C' ? " ":location);
  //obj.LOCD=(stkGrp === 'C' ? " ":LOCD);
  obj.MT = "PAYMENT_REQUEST";
  obj.PQ = PQ; //(stkGrp === 'M' ? parseFloat(PQ).toFixed(config.QuantityRoundOff):parseFloat(PQ).toFixed(2));
  obj.OMT = 2;
  obj.DN = docNo;
  try {
    if (orderWebsocket && connectionOpen === true) {
      orderWebsocket = orderSocket.getSocket();
      orderWebsocket.send(JSON.stringify(obj));
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;
}

export function cncelPaymentReq(reqDetArray) {
  return {
    type: types.CANCEL_PAYMENT_REQUEST,
    paymentReq: canclePaymentRequest(reqDetArray),
  };
}
export function canclePaymentRequest(reqDetArray) {
  const user = JSON.parse(localStorage.getItem("user"));
  const AccDet = JSON.parse(localStorage.getItem("DefaultAC"));
  if (user === null) {
    dispatch(sessionTimeout());
  }
  const platform = localStorage.getItem("platform");
  var obj = {};
  obj.SID = user.sid;
  obj.UUID = user.authToken;
  obj.UID = user.id;
  obj.UCD = user.name;
  obj.OMT = 6;
  obj.CID = user.location;
  obj.MT = "PAYMENT_REQUEST";
  let arr = [];
  reqDetArray.map((item) => {
    let obj1 = {
      CCY: item.stk_type,
      CCYN: item.cmdty,
      DN: item.docNo,
      AC: item.accCode,
      VD: moment(item.valdate).format("YYYY/MM/DD"),
      PQ: parseFloat(item.quantity),
    };
    arr.push(obj1);
  });
  obj.ARR = arr;
  try {
    if (orderWebsocket && connectionOpen === true) {
      orderWebsocket = orderSocket.getSocket();
      orderWebsocket.send(JSON.stringify(obj));
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;
}
// close PaymentFailed flag
export function onClosePayFailedModal(flag) {
  return {
    type: types.PAYMENT_FAILED_FLAG,
    flag,
  };
}
// placed OCO order
export function handleOCOOrderPlace(
  cmdtyID,
  Price1,
  Price2,
  quantity,
  stkCode,
  orderType1,
  dealType1,
  orderType2,
  dealType2,
  remark,
  ValueDate,
  ValidityType,
  CTID1,
  CTID2,
  dateTime,
  OMT,
  PCT
) {
  return {
    type: activitType.DEAL_FAILED_FLAG,
    order: placeOcoOrder(
      cmdtyID,
      Price1,
      Price2,
      quantity,
      stkCode,
      orderType1,
      dealType1,
      orderType2,
      dealType2,
      remark,
      ValueDate,
      ValidityType,
      CTID1,
      CTID2,
      dateTime,
      OMT,
      PCT
    ),
  };
}
export function placeOcoOrder(cmdtyID, Price1, Price2, quantity, stkCode, orderType1, dealType1, orderType2, dealType2, remark, ValueDate, ValidityType, CTID1, CTID2, dateTime, OMT, PCT) {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const AccDet = JSON.parse(localStorage.getItem('DefaultAC'));
    if (user === null) {
      dispatch(sessionTimeout());
    }
    let isStop = false;
    if (orderType1 === appConstants.STOP_ORD_TYPE || orderType2 === appConstants.STOP_ORD_TYPE) {
      isStop = true;
    }
    let tempArr = [{ "DT": dealType1, "PQ": quantity, "R": Price1, "CTID": CTID1, "DOT": orderType1 },
    { "DT": dealType2, "PQ": quantity, "R": Price2, "CTID": CTID2, "DOT": orderType2 }];
    var obj = {};
    obj.MT = "NEW_ORDER";
    obj.UID = user.id;
    obj.UCD = user.name;
    obj.IID = cmdtyID;
    //obj.PQ=(Quantity === '' ? 0 : Quantity);
    obj.OT = 6;//OT=6 OCO order OT=2=STOP order
    obj.CID = user.location;
    obj.AC = AccDet.AC;
    obj.AD = AccDet.AD;
    obj.SC = stkCode;
    obj.ST = "";
    obj.OMT = OMT;
    obj.PCT = PCT;
    obj.UUID = user.authToken;
    obj.RMK = remark;
    obj.DRMK = "";
    obj.MD = -1;
    obj.VD = ValueDate;
    obj.SID = user.sid;
    obj.VT = ValidityType; //validity, ValidityType class
    obj.TIME = dateTime;//epoch UTC timestamp
    obj.OrderDet = tempArr;
    obj.isStop = isStop;
    obj.OMC = 0;
    obj.isSNEXrmk = false;
    try {
      if (orderWebsocket && connectionOpen === true) {
        orderWebsocket = orderSocket.getSocket();
        orderWebsocket.send(JSON.stringify(obj));
      }
      else {
        return false;
      }
    } catch (e) {
      return false;
    }
    return true;
  } catch (e) {
    console.log('exception ', e)
  }
}
//OCO Both order modification
export function handleModifyOCOOrder(
  CmdtyPair,
  tempQ,
  selectedMeasure,
  OMT,
  PCT,
  remark,
  VT,
  dateTime,
  isStop,
  ordDet,
  orderDetails,
  isSNEXrmk,
  ISOTO = false,
  ISOCO = true,
  ISACTIVE = true,
  isLooped = false,
  otoLinkedIdArr = [],
  linkedOrdIdArr = [],
) {
  return {
    type: activitType.DEAL_FAILED_FLAG,
    order: ocoOrderModify(
      CmdtyPair,
      tempQ,
      selectedMeasure,
      OMT,
      PCT,
      remark,
      VT,
      dateTime,
      isStop,
      ordDet,
      orderDetails,
      isSNEXrmk,
      ISOTO,
      ISOCO,
      ISACTIVE,
      isLooped,
      otoLinkedIdArr,
      linkedOrdIdArr
    ),
  };
}
function ocoOrderModify(
  CmdtyPair,
  tempQ,
  Measure,
  OMT,
  PCT,
  remark,
  VT,
  dateTime,
  isStop,
  ordDet,
  orderDetails,
  isSNEXrmk,
  ISOTO,
  ISOCO,
  ISACTIVE,
  isLooped,
  otoLinkedIdArr,
  linkedOrdIdArr) {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user === null) {
    dispatch(sessionTimeout());
  }
  let [ord1, ord2] = ordDet;
  ord1 = { ...ord1, OtoLinkOrdId: otoLinkedIdArr?.[0] ?? "", LinkOrdId: linkedOrdIdArr?.[0] ?? "" };
  ord2 = { ...ord2, OtoLinkOrdId: otoLinkedIdArr?.[1] ?? "", LinkOrdId: linkedOrdIdArr?.[1] ?? "" };
  var obj = {};
  obj.UID = user.id;
  obj.UCD = user.name;
  obj.IID = CmdtyPair;
  obj.PQ = tempQ;
  obj.OPQ = orderDetails.quantity ?? orderDetails.PQ;
  obj.OT = 6; //FOR oco, ot =6
  obj.isStop = isStop;
  obj.OrderDet = [ord1, ord2];
  obj.CID = user.location;
  obj.AC = orderDetails.accCode ?? orderDetails.AC;
  obj.AD = orderDetails.accDescription ?? orderDetails.AD;
  obj.VD = orderDetails.VD;
  if (Measure === "") {
    obj.SC = "";
  } else {
    obj.SC = Measure;
  }
  obj.ST = "";
  obj.OMT = OMT;
  obj.PCT = PCT;
  obj.UUID = user.authToken;
  obj.RMK = remark;
  obj.SID = user.sid;
  obj.VT = VT; //validity, ValidityType class
  obj.OMC = 1; //order modification count
  obj.TIME = dateTime; //epoch UTC timestamp
  obj.OVT = orderDetails.VT;
  obj.OSC = orderDetails.OSC;
  obj.HSE = orderDetails.HSE;
  obj.OTIME = ord1.OTIME; //old time for GTD orders
  obj.LM = "admin";
  obj.MD = "-1";
  obj.DRMK = orderDetails.DRMK;
  obj.MT = "MODIFY_ORDER";
  obj.ISOTO = ISOTO;
  obj.ISOCO = ISOCO;
  obj.INLOOP = isLooped;
  obj.ISACTIVE = ISACTIVE;
  obj.isSNEXrmk = isSNEXrmk ? isSNEXrmk : false;
  try {
    if (orderWebsocket && connectionOpen === true) {
      orderWebsocket = orderSocket.getSocket();
      orderWebsocket.send(JSON.stringify(obj));
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;
}

/**
 *
 * Handling OTO orders
 *
 */

// Placement action
export function handleOTOOrderPlace(orderObject) {
  ////OMT=1 PCT=2
  return {
    type: activitType.DEAL_FAILED_FLAG,
    order: placeOtoOrder(orderObject),
  };
}

function placeOtoOrder(orderObject) {
  const user = JSON.parse(localStorage.getItem("user"));
  const AccDet = JSON.parse(localStorage.getItem("DefaultAC"));
  const {
    cmdtyID,
    stkCode,
    quantity,
    Price1,
    dealType1,
    orderType1,
    ValidityType1,
    dateTime1,
    Price2,
    dealType2,
    orderType2,
    ValidityType2,
    dateTime2,
    isLoopOrder,
    isOCOOrder,
    remark,
    ValueDate,
    CTID1,
    CTID2,
    CTID3,
    Price3,
    dealType3,
    orderType3
  } = orderObject;
  if (user === null) {
    dispatch(sessionTimeout());
  }
  let tempArr = [
    {
      DT: dealType1,
      R: Price1,
      CTID: CTID1,
      DOT: orderType1,
      VT: ValidityType1,
      TIME: dateTime1,
      ISACTIVE: true,
    },
    {
      DT: dealType2,
      R: Price2,
      CTID: CTID2,
      DOT: orderType2,
      VT: ValidityType2,
      TIME: dateTime2,
      ISACTIVE: false,
    },
  ];
  if (isOCOOrder) {
    let tempobj = {
      DT: dealType3,
      R: Price3,
      CTID: CTID3,
      DOT: orderType3,
      VT: ValidityType2,
      TIME: dateTime2,
      ISACTIVE: false,
    };
    tempArr.push(tempobj);
  }

  var obj = {};
  obj.MT = "NEW_ORDER";
  obj.UID = user.id;
  obj.UCD = user.name;
  obj.IID = cmdtyID;
  obj.OT = 7; //OT=6 OCO order OT=2=STOP order OT=7 OTO order
  obj.CID = user.location;
  obj.AC = AccDet.AC;
  obj.AD = AccDet.AD;
  obj.SC = stkCode;
  obj.PQ = quantity;
  obj.ST = "";
  obj.OMT = 1;
  obj.PCT = 2;
  obj.UUID = user.authToken;
  obj.RMK = remark;
  obj.DRMK = "";
  obj.MD = -1;
  obj.VD = ValueDate;
  obj.SID = user.sid;
  obj.INLOOP = isLoopOrder;
  obj.ISOCO = isOCOOrder;
  obj.ISOTO = true;
  obj.OrderDet = tempArr;
  obj.OMC = 0;
  obj.isSNEXrmk = false;
  try {
    if (orderWebsocket && connectionOpen === true) {
      orderWebsocket = orderSocket.getSocket();
      orderWebsocket.send(JSON.stringify(obj));
    } else {
      return false;
    }
  } catch (e) {
    console.log(" e " + e);
    return false;
  }
  return true;
}

export function handleOTOOrderModify(orderObject) {
  try {
    return {
      type: activitType.DEAL_FAILED_FLAG,
      order: modifyOTO(orderObject),
    };
  } catch (e) {
    console.log(" exception " + e);
  }
}

function modifyOTO(orderObject) {
  const {
    orderDetails,
    linkOrderDetails,
    quantity,
    stkCode,
    Price1,
    dealType1,
    orderType1,
    ValidityType1,
    dateTime1,
    Price2,
    dealType2,
    orderType2,
    ValidityType2,
    dateTime2,
    isLoopOrder,
    isOCOOrder,
    remark,
    valueDate,
    CTID1,
    CTID2,
    CTID3,
    Price3,
    dealType3,
    orderType3,
    ISOTO,
    isOrd1Modified,
    isOrd2Modified,
    isOCO1Modified,
    isOCO2Modified,
    isSNEXrmk
  } = orderObject;
  // check if user is logged in
  const user = JSON.parse(localStorage.getItem("user"));
  const AccDet = JSON.parse(localStorage.getItem("DefaultAC"));
  if (user === null) {
    dispatch(sessionTimeout());
  }

  let tempArr = [];
  let ord1Obj = {};
  let ord2Obj = {};
  let ord3Obj = {};
  ord1Obj.DT = parseFloat(dealType1);
  ord1Obj.R = Price1;
  ord1Obj.CTID = CTID1;
  ord1Obj.DOT = orderType1;
  ord1Obj.VT = ValidityType1;
  ord1Obj.TIME = dateTime1;
  ord1Obj.ISACTIVE = true;
  ord1Obj.OR = parseFloat(orderDetails.OR);
  ord1Obj.OTIME = linkOrderDetails[0].TIME;
  ord1Obj.OVT = linkOrderDetails[0].VT;
  ord1Obj.PCLD = orderDetails.id;
  ord1Obj.NOD = linkOrderDetails[0].NOD; // need to check if this is correct by testing
  ord1Obj.ISMOD = isOrd1Modified;
  tempArr.push(ord1Obj);

  if (orderDetails.ISOCO) {
    let ocoOrd1 = linkOrderDetails[1];
    ord2Obj.DT = parseFloat(dealType2);
    ord2Obj.R = Price2;
    ord2Obj.CTID = CTID2;
    ord2Obj.DOT = orderType2;
    ord2Obj.VT = ValidityType2;
    ord2Obj.TIME = dateTime2;
    ord2Obj.ISACTIVE = ocoOrd1.ISACTIVE;
    ord2Obj.OR = parseFloat(ocoOrd1.R);
    ord2Obj.OTIME = ocoOrd1.TIME;
    ord2Obj.OVT = ocoOrd1.VT;
    ord2Obj.PCLD = ocoOrd1.ID;
    ord2Obj.NOD = ocoOrd1.NOD;
    ord2Obj.ISMOD = isOCO2Modified;
    tempArr.push(ord2Obj);

    let ocoOrd2 = linkOrderDetails[2];
    ord3Obj.DT = parseFloat(dealType3);
    ord3Obj.R = Price3;
    ord3Obj.CTID = CTID3;
    ord3Obj.DOT = orderType3;
    ord3Obj.VT = ValidityType2;
    ord3Obj.TIME = dateTime2;
    ord3Obj.ISACTIVE = ocoOrd2.ISACTIVE;
    ord3Obj.OR = parseFloat(ocoOrd2.R);
    ord3Obj.OTIME = ocoOrd2.TIME;
    ord3Obj.OVT = ocoOrd2.VT;
    ord3Obj.PCLD = ocoOrd2.ID;
    ord3Obj.NOD = ocoOrd2.NOD;
    ord3Obj.ISMOD = isOCO2Modified;
    tempArr.push(ord3Obj);
  } else {
    ord2Obj.DT = parseFloat(dealType2);
    ord2Obj.R = Price2;
    ord2Obj.CTID = CTID2;
    ord2Obj.DOT = orderType2;
    ord2Obj.VT = ValidityType2;
    ord2Obj.TIME = dateTime2;
    ord2Obj.ISACTIVE = linkOrderDetails[1].ISACTIVE;
    ord2Obj.OR = parseFloat(linkOrderDetails[1].R);
    ord2Obj.OTIME = linkOrderDetails[1].TIME;
    ord2Obj.OVT = linkOrderDetails[1].VT;
    ord2Obj.PCLD = linkOrderDetails[1].ID;
    ord2Obj.NOD = linkOrderDetails[1].NOD;
    ord2Obj.ISMOD = isOrd2Modified;
    tempArr.push(ord2Obj);
  }

  let obj = {};
  obj.MT = "MODIFY_ORDER";
  obj.UID = user.id;
  obj.UCD = user.name;
  obj.IID = orderDetails.cmdtyId;
  obj.OT = appConstants.OTO_ORD_TYPE;
  obj.CID = user.location;
  obj.AC = orderDetails.accCode;
  obj.AD = orderDetails.accDescription;
  obj.SC = stkCode;
  obj.PQ = parseFloat(quantity);
  obj.OSC = orderDetails.OSC;
  obj.OPQ = orderDetails.quantity;
  obj.ST = "";
  obj.OMT = 2;
  obj.PCT = 3;
  obj.UUID = user.authToken;
  obj.RMK = remark;
  obj.DRMK = orderDetails.DRMK;
  obj.MD = -1;
  obj.OMC = 1;
  obj.VD = valueDate;
  obj.SID = user.sid;
  obj.INLOOP = orderDetails.INLOOP;
  obj.ISOCO = orderDetails.ISOCO;
  obj.ISOTO = true;
  obj.OrderDet = tempArr;
  obj.isSNEXrmk = isSNEXrmk ? isSNEXrmk : false;
  try {
    if (orderWebsocket && connectionOpen === true) {
      // is active needs to be taken from tradebook
      if (linkOrderDetails && linkOrderDetails.length) {
        const [linkedOrd1, linkedOrd2, linkedOrd3] = linkOrderDetails;
        const isStop = linkedOrd2.OT === appConstants.STOP_ORD_TYPE || linkedOrd1.OT === appConstants.STOP_ORD_TYPE
        let isOCO = true;
        let isOTO = true;
        let isLooped = linkedOrd2.INLOOP;
        if (!!linkedOrd2.ISACTIVE) {
          // order 1 is inactive, 2nd order is active
          if (linkedOrd2.OT !== appConstants.OCO_ORD_TYPE) {
            isOCO = false;
            handleModifyLMTOrder(
              linkedOrd2.IID,
              quantity,
              stkCode,
              dealType2,
              Price2,
              orderType2,
              2,
              3,
              remark,
              ValidityType2,
              CTID2,
              dateTime2,
              orderDetails.quantity,
              parseFloat(linkedOrd2.R),
              linkedOrd2.VT,
              orderDetails.OSC,
              linkedOrd2.NOD,
              orderDetails.BID,
              orderDetails.id,
              orderDetails.DRMK,
              orderDetails.HSE,
              valueDate,
              AccDet.AC,
              AccDet.AD,
              linkedOrd2.TIME,
              isSNEXrmk,// fix RD#380905 - wrong position of isSNEXrmk parameter
              orderType2,
              isOTO,
              isOCO,
              linkedOrd2.ISACTIVE,
              linkedOrd2.OtoLinkOrdId,
              isLooped
            )
          } else {
            isOCO = true;
            const order1 = { ...tempArr[1], PQ: quantity };
            const order2 = { ...tempArr[2], PQ: quantity };
            const orderDetails = [order1, order2];
            const otoLinkedIdArr = [linkedOrd2?.OtoLinkOrdId, linkedOrd3?.OtoLinkOrdId];
            const linkedOrdIdArr = [linkedOrd2?.LinkOrdId, linkedOrd3?.LinkOrdId];
            // linkedOrd2 is sent in place of orderDetails param as it is required for 
            // OCO order params such as AC, AD, OVT, etc.
            handleModifyOCOOrder(
              linkedOrd2.IID,
              quantity,
              stkCode,
              2,
              3,
              remark,
              order1.VT,
              dateTime2,
              isStop,
              orderDetails,
              linkedOrd2,
              isSNEXrmk,// fix RD#380905 - wrong position of isSNEXrmk parameter
              isOTO,
              isOCO,
              linkedOrd2.ISACTIVE,
              isLooped,
              otoLinkedIdArr,
              linkedOrdIdArr
            )
          }
        } else {
          orderWebsocket = orderSocket.getSocket();
          orderWebsocket.send(JSON.stringify(obj));
        }
      }
    } else {
      return false;
    }
  } catch (e) {
    console.log("Exception: OTOMOD", e, obj);
    return false;
  }
  return true;
}

export function placeFWDTrade(data) {
  return (dispatch) => {
    dispatch(CommonActions.handleAPICall(data, '/fwdDealRequest', types.PLACE_FWD_TRADE, 'POST',{QID: data.QID}));
  };
}

export function placeSWPTrade(data) {
  return (dispatch) => {
    dispatch(CommonActions.handleAPICall(data, '/swapDealRequest', types.PLACE_SWP_TRADE, 'POST',{QID: data.QID}));
  };
}
